import {
  transformEWACalendar,
  transformEWADetails,
  transformEWASchedulingValidation,
} from '@/common/integrations/menhir/employee/salary/salary.dto';
import {
  IMenhirEWACalendarPeriod,
  IMenhirEWADetails,
  IMenhirEWASchedulingValidation,
} from '@/common/integrations/menhir/employee/salary/salary.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { TMoney } from '@coverflex-tech/hypernova-utils';

export const getEWADetails = () =>
  menhirClient
    .get<null, IMenhirEWADetails>(MENHIR_ENDPOINTS.EMPLOYEE.SALARY.EWA.DETAILS)
    .then(transformEWADetails);

export const submitEWARequest = (amount: TMoney) =>
  menhirClient.post<null, IMenhirEWADetails>(
    MENHIR_ENDPOINTS.EMPLOYEE.SALARY.EWA.REQUEST,
    {
      amount: {
        amount: amount.amount,
        currency: amount.currency,
      },
    }
  );

export const validateEWAScheduling = (frequency: number) =>
  menhirClient
    .post<null, IMenhirEWASchedulingValidation>(
      MENHIR_ENDPOINTS.EMPLOYEE.SALARY.EWA.SCHEDULE_VALIDATE,
      {
        frequency,
      }
    )
    .then(transformEWASchedulingValidation);

export const createEWAScheduling = (frequency: number) =>
  menhirClient.post<null, IMenhirEWASchedulingValidation>(
    MENHIR_ENDPOINTS.EMPLOYEE.SALARY.EWA.SCHEDULE_CONFIRM,
    {
      frequency,
    }
  );

export const cancelEWAScheduling = () =>
  menhirClient.delete(MENHIR_ENDPOINTS.EMPLOYEE.SALARY.EWA.SCHEDULE);

export const updateEWAScheduling = (newFrequency: number) =>
  menhirClient.put(MENHIR_ENDPOINTS.EMPLOYEE.SALARY.EWA.SCHEDULE, {
    frequency: newFrequency,
  });

export const getEWACalendar = (frequency?: number) =>
  menhirClient
    .get<null, IMenhirEWACalendarPeriod[][]>(
      MENHIR_ENDPOINTS.EMPLOYEE.SALARY.EWA.CALENDAR,
      {
        params: {
          frequency,
        },
      }
    )
    .then(transformEWACalendar);

export const SalaryService = {
  getEWADetails,
  submitEWARequest,
  validateEWAScheduling,
  createEWAScheduling,
  cancelEWAScheduling,
  updateEWAScheduling,
  getEWACalendar,
};
